import { SquarePenIcon } from 'lucide-react';

export const DraftIcon = SquarePenIcon;
export default DraftIcon;
